<template>
    <div>
        <div class="row">
            <div class="col-lg-3">
                <div class="form-group">
                    <label for="datainicial">
                        Data Inicial Demonstração:
                    </label>
                    <input class="form-control" type="date" id="datainicial" v-model="startDate"/>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group">
                    <label for="datainicial">
                        Data Final Demonstração:
                    </label>
                    <input class="form-control" type="date" id="datafinal" v-model="endDate"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <button type="button" class="btn btn-primary" @click="filterTable">Filtrar</button>
            </div>
        </div>
        <div style="overflow-x:auto; margin-top: 20px">
            <table id="users_table" class="table table-responsive table-hover table-mail">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Usuário</th>
                        <!--th>Email</th-->
                        <th>Produto</th>
                        <th>Data Início</th>
                        <th>Data Fim</th>
                        <th>Plano Contratado</th>
                        <th>Ações</th>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props:{ 
        },
        data() {
            return { 
                startDate: null,
                endDate: null,
            }
        }, 
        methods: {
        },
        mounted(){

            var vm = this;

            $(document).ready(function () {
                
                vm.dataTable = $('#users_table').DataTable({
                    searching:false,
                    serverSide:true,
                    ajax:{
                        url:'/admin/users/demo-products/list',
                        method:'GET',
                        data:{'start_date':''}
                    },
                    columns:[
                        {
                            data:'id'
                        },
                        {
                            data:'user.full_name',
                            render:function(data, type, row, meta){
                                return '<a target="_blank" href="/admin/users/'+row.user.id+'">'+data+'</a>';
                            }

                        },
                        // {
                        //     data:'user.email'
                        // },
                        {
                            data:'product'
                        }, 
                        {
                            data:'start_date'
                        }, 
                        {
                            data:'final_date'
                        }, 
                        {
                            render:function(data, type, row, meta)
                            {
                                if ( row.user.payment_recurrent_id != null )
                                {
                                    return 'Sim';
                                }
                                else
                                {
                                    return 'Não'
                                }
                            }
                        },
                        {
                            data:'created_at',
                            render:function(data, type, row, meta){
  
                                return '<button class="btn btn-primary remove-demo" data-user-id="'+row.id+'">Remover</button>';

                            }
                        }
                    ],
                    drawCallback: function(settings){

                        $(".remove-demo").on('click', function (e) {
                            vm.removeDemo(e.target.dataset.userId);
                        });

                    }

                });

                vm.dataTable.on('preXhr.dt', function(e, settings, data){
                    data.startDate = vm.startDate;
                    data.endDate = vm.endDate;
                });

            });
        },
        methods: {
            filterTable(){
                this.dataTable.ajax.reload();
            },
            removeDemo(id) {

                if (confirm('Tem certeza que deseja excluir demostração do usuário?')){

                    axios.delete('/admin/users/demo-products/'+id)
                    .then((response) => {

                        if (response.data.success) {
                            
                            toastr.success('Demostração excluída.');    

                            this.dataTable.ajax.reload();

                        }else{
                            toastr.error('Erro ao tentar excluir demonstração.');        
                        }
                        
                    })
                    .catch((err) => {

                        toastr.error('Erro ao excluir demonstração.');

                    });
                    
                }
                
            }
        }
    }
</script>